import { REMINDER_MINUTES } from '@iqrapath/shared'
import { useId } from 'react'

const HOURS = Array.from({ length: 24 }, (_, h) => h)
const pad = (n: number) => String(n).padStart(2, '0')

/** Hour + minute (quarter hours, the push scheduler runs every 15 minutes), always WIB. Onboarding and Pengaturan. */
export function ReminderTime({ hour, minute, onChange }: { hour: number; minute: number; onChange: (hour: number, minute: number) => void }) {
  const ids = { hour: useId(), minute: useId() }
  return (
    <div className="set-row time-row">
      <label htmlFor={ids.hour}>Jam</label>
      <select id={ids.hour} className="input" value={hour} onChange={(e) => onChange(Number(e.target.value), minute)}>
        {HOURS.map((h) => <option key={h} value={h}>{pad(h)}</option>)}
      </select>
      <span aria-hidden="true">:</span>
      <label htmlFor={ids.minute} className="sr">Menit</label>
      <select id={ids.minute} className="input" value={minute} onChange={(e) => onChange(hour, Number(e.target.value))}>
        {REMINDER_MINUTES.map((m) => <option key={m} value={m}>{pad(m)}</option>)}
      </select>
      <span className="muted">WIB</span>
    </div>
  )
}
